import React from 'react';
import '@/styles/globals.scss';
import styles from '@/styles/App.module.scss';
import type { AppProps } from 'next/app';
import { Header, Footer } from '@/shared';
import { ContextWrapper } from '@/components';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <div className='parentContainer'>
      <ContextWrapper>
        <div className={styles['header-container']}>
          <div className='header-wrapper'>
            <Header />
          </div>
        </div>

        <div className='body-container'>
          <div className='body-wrapper'>
            <main className='container'>
              <Component {...pageProps} />
            </main>
            <Footer />
          </div>
        </div>
      </ContextWrapper>
    </div>
  );
}
